exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".investoren{color:red}select:disabled{background-color:#ebebe4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/forms/investoren/investoren.scss
// module id = 486
// module chunks = 0